import { Stack } from '@mui/material';
import { PromptLibraryIcon } from '../PromptLibraryIcon';
import { Button, colors, Typography } from '@sweep-io/sweep-design';
import { usePrompt } from '../usePrompt';
import useSendBiEvent from '../../../../hooks/useSendBiEvent';
import { AI_AGENTS_EVENTS } from '../../../../services/events';

export const SinglePromptTitleLayout = ({
  iconName,
  title,
  description,
  groupId,
}: {
  iconName?: string;
  title: string;
  description?: string;
  groupId: string;
}) => {
  const { addEmptyPrompt } = usePrompt();
  const sendBiEvent = useSendBiEvent();

  const onNewPromptClick = () => {
    sendBiEvent({ name: AI_AGENTS_EVENTS.promptsLibraryNewPromptClick });
    addEmptyPrompt(groupId);
  };

  return (
    <Stack direction="row" alignItems="baseline" justifyContent="space-between">
      <Stack>
        <Stack
          direction="row"
          alignItems="center"
          gap={1}
          pb={2}
          sx={{ svg: { width: '24px', height: '24px' } }}
        >
          {iconName && <PromptLibraryIcon icon={iconName} />}
          <Typography variant="h1" whiteSpace="break-spaces" wordBreak="break-word">
            {title}
          </Typography>
        </Stack>
        {description && (
          <Stack pb={2}>
            <Typography variant="h4" color={colors.grey[700]}>
              {description}
            </Typography>
          </Stack>
        )}
      </Stack>

      <Stack sx={{ button: { whiteSpace: 'nowrap' } }}>
        <Button variant="secondary" startIconName="Plus" onClick={onNewPromptClick}>
          New prompt
        </Button>
      </Stack>
    </Stack>
  );
};
